import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getCollectionFacet,
  GetCollectionFacetResponse,
} from '@/services/data-sources/get-collection-facet';

interface UseGetCollectionFacetOptions extends Omit<
  UseQueryOptions<GetCollectionFacetResponse>,
  'queryKey' | 'queryFn'
> {
  collectionId?: string;
  field?: string;
  orgId?: string;
  limit?: number;
  exact?: boolean;
}

export const useGetCollectionFacet = (
  options?: UseGetCollectionFacetOptions,
) => {
  const {
    collectionId,
    field,
    orgId,
    limit = 100,
    exact = false,
    ...queryOptions
  } = options || {};

  return useQuery<GetCollectionFacetResponse>({
    queryKey: ['collection-facet', orgId, collectionId, field, limit, exact],
    queryFn: async () => {
      if (!collectionId || !field) {
        throw new Error('collectionId and field are required');
      }
      return getCollectionFacet({ collectionId, field, limit, exact });
    },
    enabled: !!collectionId && !!field && !!orgId,
    // Backend caches 15 min. FE can cache a bit shorter so reopening
    // the modal in rapid succession still gets fresh hits when the
    // user just ingested data.
    staleTime: 5 * 60 * 1000,
    retry: false,
    ...queryOptions,
  });
};
